/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var DocActions;
    (function (DocActions) {
        const LOG_CATEGORY = "WPT.DocumentActions.PseudoSystemTasks";
        class DocActionPseudoSysTask extends DocActions.DocActionBaseClass {
            constructor(core, name, pSysTaskIdentifier = null) {
                super(core, name);
                this._pstDefinition = null;
                this._modalSession = null;
                this._executePseudoSystemTask = (comment) => {
                    this._log.info("DocActionPseudoSysTask._executePseudoSystemTask()");
                    let modalSession = 'system-task-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                        this._modalSession = modalSession;
                    }
                    let request = {
                        TaskIdentifier: this._pstDefinition.Identifier,
                        Comment: comment
                    };
                    this._core.Loader.genericServiceCallWithData(`/Workflow.svc/rest/ExecutePseudoSystemTask/${this._pendingRequest.DocHandle.toString()}`, JSON.stringify(request), this._pseudoSystemTaskTaskComplete, {}, this._errorCallback, this._failCallback);
                };
                this._pseudoSystemTaskTaskComplete = () => {
                    this._log.info("DocActionPseudoSysTask._pseudoSystemTaskTaskComplete()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    // May need to refreash the view - documents may have changed or moved out of the queue
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(null, WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_PSEUDO_SYSTASK);
                    navEvent.ActivationID = 0;
                    navEvent.PrimaryContext = this._pstDefinition;
                    navEvent.AdditionalContext = { "Document": this._pendingRequest.Document };
                    // Set default layout as current, but check if we've had an alternative requested against the instance
                    navEvent.Layout = this._core.Navigation.Details.getActiveLayoutName();
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._failCallback = (json) => {
                    this._log.info("DocActionPseudoSysTask._failCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    let response = json;
                    console.warn(response.Connection.Message);
                    this._core.Helper.presentWarningModal(response.Connection.Message);
                };
                this._errorCallback = (url, status, message) => {
                    this._log.info("DocActionPseudoSysTask._errorCallback()");
                    if (this._modalSession) {
                        this._core.Helper.closeBusyModal(this._modalSession);
                        this._modalSession = null;
                    }
                    console.warn(message);
                    this._core.Helper.presentWarningModal(message);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocActionPseudoSysTask::constructor");
                // Got to have a task to attach to, otherwise leave in unusable state
                if (!pSysTaskIdentifier) {
                    console.error("Attempt to instantiate pseudo-system task doc action with no PST specified.");
                    return;
                }
                this._pstDefinition = this._core.OBHelper.PseudoSystemTaskMap[pSysTaskIdentifier];
                if (!this._pstDefinition) {
                    console.error("Attempt to instantiate pseudo-system task doc action with unknown PST specified.");
                    return;
                }
                this._name = `${this._name}:${pSysTaskIdentifier}`;
                this._label = this._pstDefinition.Label;
                this._readyToExecute = true;
                if (this._pendingRequest)
                    this.execute(this._pendingRequest);
            }
            actionAllowed(request) {
                this._log.info("DocActionPseudoSysTask.actionAllowed()");
                if ((this._pstDefinition.DocTypes.indexOf('*') > -1) || (this._pstDefinition.DocTypes.indexOf(request.DocumentType.Name) > -1))
                    return true;
                else
                    return false;
            }
            execute(request) {
                this._log.info("DocActionPseudoSysTask.execute()");
                this._pendingRequest = request;
                if (!this._readyToExecute) {
                    return;
                }
                this._core.OBHelper.ActionHelper.executeAction(this._pstDefinition.ActionInfo, this._pendingRequest.Document, this._executePseudoSystemTask);
            }
        }
        DocActions.DocActionPseudoSysTask = DocActionPseudoSysTask;
    })(DocActions = WPTNamespace.DocActions || (WPTNamespace.DocActions = {}));
})(WPTNamespace || (WPTNamespace = {}));
